import { gql } from '../../../__gql-types__/gql'

export const sendFeatureRequest = gql(`
	mutation SendFeatureRequest (
		$message: String!,
		$page: String!
	) {
		sendFeatureRequest (
			message: $message,
			page: $page,
		)
	}
`)
